import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
var $t = Vue.prototype.$t;
export var tabPaneArr = [{
  name: 'work_rule_13',
  title: 'step1',
  comp: function comp() {
    return import('./step1.vue');
  },
  id: 1 // 考勤设置
}, {
  name: 'payroll_wage_14',
  title: 'step2',
  comp: function comp() {
    return import('./step2');
  },
  id: 2 // 工资设置
}];

export var data = {
  info: {
    sub_project_name: '',
    // 子项目名称
    staff_ids: [],
    // 员工Id列表
    department_ids: [],
    project_id: '',
    // 主项目ID
    pay_month: '',
    // 计薪月份
    start_date: '',
    // 薪资周期开始日期
    end_date: '',
    // 薪资周期结束日期
    att_start_date: '',
    // 考勤周期开始日期
    att_end_date: '',
    // 考勤周期结束日期
    leave_start_date: '',
    // 离职日期开始日期
    leave_end_date: '',
    // 离职日期结束日期
    settlement_type: '',
    // 结算方式
    pay_method: '',
    // 发薪方式
    staff_state: [],
    // 员工在职状态
    staff_formal: [],
    // 员工属性
    pay_date: '',
    // 发薪日期
    tax_deduction_status: '' // 税
  },

  ruleForm: {
    sub_project_name: [{
      required: true,
      message: $t('1019'),
      trigger: 'blur'
    } // 请输入子项目名称
    ],

    pay_month: [{
      required: true,
      message: $t('1018'),
      trigger: 'change'
    } // 请输入月份
    ],

    start_date: [{
      required: true,
      message: $t('839'),
      trigger: 'change'
    } // 请选择日期
    ],

    att_start_date: [{
      required: true,
      message: $t('839'),
      trigger: 'change'
    } // 请选择日期
    ],

    leave_start_date: [{
      required: true,
      message: $t('839'),
      trigger: 'change'
    } // 请选择日期
    ],

    settlement_type: [{
      required: true,
      message: $t('1011'),
      trigger: 'change'
    } // 请选择结算方式
    ],

    pay_method: [{
      required: true,
      message: $t('797'),
      trigger: 'change'
    } // 请选择发薪方式
    ],

    pay_date: [{
      required: true,
      message: $t('839'),
      trigger: 'change'
    }],
    staff_state: [{
      required: true,
      message: $t('799'),
      trigger: 'change'
    } // 请选择员工状态
    ],

    leave_end_date: [{
      required: true,
      message: $t('1014'),
      trigger: 'change'
    } // 请选择离职日期
    ],

    staff_formal: [{
      required: true,
      message: $t('800'),
      trigger: 'change'
    }],
    tax_deduction_status: [{
      required: true,
      message: $t('basic_info_12'),
      trigger: 'change'
    }]
  },
  state: '',
  // 当前子项目状态
  payroll_sub_project_scheme_id: '0',
  radio: '',
  sub_project_id: ''
};